import React, { Fragment } from 'react';
import styled from 'styled-components';
import LicenseDisplayGroup from './license_display_group';
import Skeleton from '../skeleton';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  padding-top: 20px;
`;

const DesktopDisplayGroupsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileDisplayGroupsWrapper = styled.div`
  display: none;
  flex-direction: column;

  @media (max-width: 800px) {
    display: flex;
  }
`;

class LicenceSelectorScreenV2Content extends React.Component {

  render = () => {
    return (
      <ContentWrapper>
        {this.props.licencesLoading ? (<Skeleton nbCols={2} expand={true}></Skeleton>
        ) :
        <>
          <DesktopDisplayGroupsWrapper>
            {(this.props.licenseDisplayGroups.map((group, idx) => {
              return <Fragment key={idx}>
                  <LicenseDisplayGroup
                    licenseDisplayGroup={group}
                    isSaving={this.props.isSaving}
                    onAddSoftwareLicencesRequested={this.props.onAddSoftwareLicencesRequested}
                    softwareSelection={this.props.softwareSelection}
                    knowMoreLinksMap={this.props.knowMoreLinksMap}
                  />
              </Fragment>
            }))}

          </DesktopDisplayGroupsWrapper>
          <MobileDisplayGroupsWrapper>
            {(this.props.licenseDisplayGroups.filter(displayGroup => displayGroup.displayGroupKey === this.props.mobileSelectedLicenseDisplayGroup)
              .map((group, idx) => {
              return <Fragment key={idx}>
                <LicenseDisplayGroup
                  licenseDisplayGroup={group}
                  isSaving={this.props.isSaving}
                  onAddSoftwareLicencesRequested={this.props.onAddSoftwareLicencesRequested}
                  softwareSelection={this.props.softwareSelection}
                  knowMoreLinksMap={this.props.knowMoreLinksMap}
                />
              </Fragment>
            }))}
          </MobileDisplayGroupsWrapper>

        </>
        }
      </ContentWrapper>
    );
  }
}

export default LicenceSelectorScreenV2Content;
